// Breadcrumb trail for support tickets — a small in-memory ring buffer of
// what the user has been doing (route changes, mutating API calls, API
// errors). Attached invisibly to support tickets so a platform admin can
// reproduce the issue without interrogating the submitter.
//
// Deliberately NEVER records request/response bodies — only method + path +
// status — so no PII, secrets, or subscriber content can leak into a ticket.

const MAX_ENTRIES = 30;
const trail = [];

export function recordBreadcrumb(entry) {
  trail.push({ t: new Date().toISOString(), ...entry });
  if (trail.length > MAX_ENTRIES) trail.shift();
}

export function getBreadcrumbs() {
  return [...trail];
}

// The full diagnostic payload a support ticket carries (hidden from the
// submitter; rendered only in the admin console).
export function buildSupportContext({ role } = {}) {
  return {
    url: window.location.href,
    route: window.location.pathname,
    user_agent: navigator.userAgent,
    viewport: `${window.innerWidth}x${window.innerHeight}`,
    build: typeof __VERSO_VERSION__ !== 'undefined' ? __VERSO_VERSION__ : 'dev',
    role: role ?? null,
    captured_at: new Date().toISOString(),
    breadcrumbs: getBreadcrumbs(),
  };
}
